import {
  titleUI,
  radioUI,
  radioSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { childRelationshipToVeteranOptions } from '../../utils/labels';

export default {
  uiSchema: {
    ...titleUI('Your relationship to the Veteran'),
    childRelationshipToVeteran: radioUI({
      title: 'What’s your relationship to the Veteran?',
      labels: childRelationshipToVeteranOptions,
    }),
  },
  schema: {
    type: 'object',
    required: ['childRelationshipToVeteran'],
    properties: {
      childRelationshipToVeteran: radioSchema(
        Object.keys(childRelationshipToVeteranOptions),
      ),
    },
  },
};
